export default "__VITE_ASSET__CndqC$fo__"